"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitCasesTitleID = exports.getModelTypeFromLawLex = exports.getModelTypeFromLawLexEnds = exports.getDocumentTitle = void 0;
var LawLex_1 = require("@livv/models/LawLex");
var modelType_1 = require("@livv/models/modelType");
// Analysis is fetch from decision, do it from related code in apps
var getDocumentTitle = function (documentData, modelType) {
    switch (modelType) {
        case modelType_1.ModelType.ARTICLE:
        case modelType_1.ModelType.DECISION:
        case modelType_1.ModelType.GLOSSARY_TERM:
        case modelType_1.ModelType.LAW_TEXT:
        case modelType_1.ModelType.STATISTIC:
        default:
            // Force to return a string and not an empty string, because it's not possible to have an empty title
            return documentData.title;
    }
};
exports.getDocumentTitle = getDocumentTitle;
var getModelTypeFromLawLexEnds = function (prefix, suffix) {
    var lawLexFormat = "".concat(prefix, "_").concat(suffix);
    switch (true) {
        case lawLexFormat === 'Art_':
            return modelType_1.ModelType.ARTICLE;
        case lawLexFormat === 'Glo_':
            return modelType_1.ModelType.GLOSSARY_TERM;
        case lawLexFormat === 'LawLex_JBA':
        case lawLexFormat === 'LawLex_JBL':
        case lawLexFormat === 'LEGIARTI_':
            return modelType_1.ModelType.LAW_TEXT;
        case lawLexFormat === 'LawLex_JBN':
            return modelType_1.ModelType.ANALYSIS;
        case lawLexFormat === 'LawLex_JBJ':
            return modelType_1.ModelType.DECISION;
        case lawLexFormat === 'Stat_':
            return modelType_1.ModelType.STATISTIC;
        default:
            return null;
    }
};
exports.getModelTypeFromLawLexEnds = getModelTypeFromLawLexEnds;
var getModelTypeFromLawLex = function (text) {
    if (!text)
        return null;
    var lawLexRegex = /(Art|Glo|LawLex|LEGIARTI|Stat)[0-9]{12}(JBA|JBJ|JBN|JBL|)/g;
    var lawLexMatches = __spreadArray([], __read(text.matchAll(lawLexRegex)), false);
    if (0 === lawLexMatches.length) {
        return modelType_1.ModelType.PUBLICATION_SHEET; // TODO - VOG-950: format publicationSheets ids;
    }
    var _a = __read(lawLexMatches[0].slice(1, 3), 2), prefix = _a[0], suffix = _a[1];
    return (0, exports.getModelTypeFromLawLexEnds)(prefix, suffix);
};
exports.getModelTypeFromLawLex = getModelTypeFromLawLex;
/**
 * Splits a list of string in two, depending whether it matches an ID regex
 * @param initial The list of cases as filled by our users
 * @returns Two lists, the first one with raw titles filled as is, the second with decision IDs
 */
var splitCasesTitleID = function (initial) {
    return initial.reduce(function (_a, sameCase) {
        var _b = __read(_a, 2), titles = _b[0], ids = _b[1];
        return LawLex_1.decisionIdRegex.test(sameCase)
            ? [titles, __spreadArray(__spreadArray([], __read(ids), false), [sameCase], false)]
            : [__spreadArray(__spreadArray([], __read(titles), false), [sameCase], false), ids];
    }, [[], []]);
};
exports.splitCasesTitleID = splitCasesTitleID;
//# sourceMappingURL=model.js.map